import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import { createTracker } from '@nrk/dh-snowplow'
import { EventSchema, ViewportEventKind } from '@nrk/snowplow-web'
import { Lydlogg } from './components/lydlogg'

import './client.css'
import './components/app.module.css'
import './components/lydlogg.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends HTMLElement {
  name = tag
  #tracker
  #entryObserver
  #exitObserver

  connectedCallback() {
    this.#defineCustomElements()

    this.#createTracker()
    this.#startViewportLogger()

    this.addEventListener('dh-lydlogg-play', (e) => {
      e.preventDefault()
      // this.sendGaEvent({
      //   eventAction: 'play',
      //   eventLabel: e.detail.mp3,
      //   eventValue: Math.round(e.detail.progress * 1000),
      // })
    })

    this.addEventListener('dh-lydlogg-stop', (e) => {
      e.preventDefault()
      // this.sendGaEvent({
      //   eventAction: 'stop',
      //   eventLabel: e.detail.mp3,
      //   eventValue: Math.round(e.detail.progress * 1000),
      // })
    })
  }

  disconnectedCallback() {
    this.#stopViewportLogger()
  }

  #createTracker() {
    if (process.env.DEV) {
      // @ts-ignore
      import('@nrk/dh-snowplow/mock')
        .then(({ mock }) => mock())
        .catch(console.error)
    }

    this.#tracker = createTracker('dh-lydlogg', {
      environment: process.env.ENVIRONMENT,
      contentContext: {
        source: 'pp',
        id: this.dataset.selfId,
      },
    })
  }

  #startViewportLogger() {
    this.#entryObserver = new IntersectionObserver((entries) => {
      if (!entries[0]?.isIntersecting) {
        return
      }
      this.#entryObserver.disconnect()
      this.#exitObserver.observe(this)
      this.#tracker.trackSelfDescribingEvent({
        schema: EventSchema.ViewportEvent,
        data: {
          kind: ViewportEventKind.Entry,
        },
      })
    }, {})

    this.#exitObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) {
          return
        }
        this.#exitObserver.disconnect()
        this.#tracker.trackSelfDescribingEvent({
          schema: EventSchema.ViewportEvent,
          data: {
            kind: ViewportEventKind.Exit,
          },
        })
      },
      { threshold: [1], rootMargin: '3000px 0px -100% 0px' },
    )

    this.#entryObserver.observe(this)
  }

  #stopViewportLogger() {
    this.#entryObserver?.disconnect()
    this.#exitObserver?.disconnect()
  }

  async #defineCustomElements() {
    safeDefine('dh-lydlogg', Lydlogg)
  }
}

safeDefine(tag, AppElement)
